import type { CSSProperties } from 'react';
import type { HtmlElementProps } from '@/types';
import { styles } from './utils';

export interface LoopingEllipsisProps extends HtmlElementProps<HTMLSpanElement> {
  delays?: [number, number, number];
  ellipsisClassName?: string;
  ellipsisStyle?: CSSProperties;
}

export default function LoopingEllipsis({
  delays = [0, 100, 200],
  ellipsisClassName,
  ellipsisStyle = {},
  children,
  ...props
}: LoopingEllipsisProps) {
  return (
    <span {...props}>
      {delays.map((delay, i) => (
        <span
          key={i}
          style={styles.ellipsis(delay, ellipsisStyle)}
          className={ellipsisClassName}>
          .
        </span>
      ))}
    </span>
  );
}
